module.exports = __webpack_public_path__ + "img/news.52c8fac6.png";